import { BehaviorSubject } from 'rxjs';
import { apiBase } from './instance';
import {
  MANAGEMENT_LOCAL_STORAGE_KEY,
  PEST_IDENTIFICATION_LOCAL_STORAGE_KEY,
  SEARCH_LOCAL_STORAGE_KEY,
  USER_LOCAL_STORE,
} from '../constants';

const currentUserSubject = new BehaviorSubject(JSON.parse(localStorage.getItem(USER_LOCAL_STORE)));
const login = ({
  username = '',
  password = '',
}) => apiBase({
  method: 'POST',
  url: '/api/auth/sign-in',
  data: {
    username,
    password,
    device: 'Web',
  },
});

const signUp = ({
  email = '',
  username = '',
  password = '',
  firstName = '',
  lastName = '',
  gender = '',
  phone = '',
  DoB = '',
  address = '',
}) => apiBase({
  method: 'POST',
  url: '/api/v1/users/applicant/registration',
  data: {
    email,
    username,
    password,
    first_name: firstName,
    last_name: lastName,
    gender,
    phone,
    birthday: DoB,
    address,
  },
});

const forgotPassword = (data) => apiBase({
  method: 'GET',
  url: `/api/users/send-mail-reset-password/${data.email}`,
});

const resetPassword = (data) => apiBase({
  method: 'POST',
  url: '/api/users/reset-password',
  data,
});

const changePassword = (data) => apiBase({
  method: 'POST',
  url: '/api/users/change-password',
  data,
});

const updateUser = (data) => {
  localStorage.setItem(USER_LOCAL_STORE, JSON.stringify(data));
  currentUserSubject.next(data);
};

const logout = (onDone) => {
  const itemsToRemove = [
    USER_LOCAL_STORE,
    SEARCH_LOCAL_STORAGE_KEY.INPUT_PRODUCTIVITY,
    SEARCH_LOCAL_STORAGE_KEY.INPUT_RICE_STRUCTURE,
    SEARCH_LOCAL_STORAGE_KEY.INPUT_PEST,
    SEARCH_LOCAL_STORAGE_KEY.INPUT_FARMING_PROGRESS,
    SEARCH_LOCAL_STORAGE_KEY.INPUT_WEATHER,
    MANAGEMENT_LOCAL_STORAGE_KEY.HARMFUL_ORGANISMS,
    MANAGEMENT_LOCAL_STORAGE_KEY.RICE_VARIETIES,
    MANAGEMENT_LOCAL_STORAGE_KEY.GROWTH_STAGE,
    MANAGEMENT_LOCAL_STORAGE_KEY.CROPS,
    MANAGEMENT_LOCAL_STORAGE_KEY.DISTRICT,
    MANAGEMENT_LOCAL_STORAGE_KEY.WARDS,
    MANAGEMENT_LOCAL_STORAGE_KEY.USERS,
    MANAGEMENT_LOCAL_STORAGE_KEY.NOTIFICATION,
    MANAGEMENT_LOCAL_STORAGE_KEY.MACHINES,
    PEST_IDENTIFICATION_LOCAL_STORAGE_KEY.IDENTIFICATION_ON_RICE,
    PEST_IDENTIFICATION_LOCAL_STORAGE_KEY.IDENTIFICATION_ON_MACHINE,
  ];

  itemsToRemove.forEach((item) => localStorage.removeItem(item));
  currentUserSubject.next(null);
  onDone();
};

const authenticationService = {
  login,
  logout,
  forgotPassword,
  signUp,
  changePassword,
  currentUser: currentUserSubject.asObservable(),
  get currentUserValue() { return currentUserSubject.value; },
  updateUser,
  resetPassword,
};

export default authenticationService;
